import React, { useEffect, useState } from "react";
import Table from "../components/Table";
import axios from "axios";
import { apiKey } from "../config/config";
import DatePicker from "react-multi-date-picker";
import { convertDateFormat } from "../services/helper";
import Receipt from "../components/Receipt";
import TextComponent from "../components/TextComponent";

function InvestorStatment({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const branchId = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin")).admin,
  ).branch_id;
  const [branch, setBranch] = useState();

  const [filter, setFilter] = useState([]);
  const [investorList, setInvestorList] = useState([]);
  const [investor, setInvestor] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [data, setData] = useState([]);
  const columns = [
    {
      header: lang["SN"] || "SN",
      cell: (row) => row.row.index + 1,
      footer: info => lang["Total"] || "Total"
    },
    {
      header: lang.date || "Date",
      cell: (row) => convertDateFormat(row.row.original.date),
    },
    {
      header: lang.Investor || "Investor",
      accessorKey: "FullName",
    },
    {
      header: lang.Deposit || "Deposit",
      accessorKey: "deposit",
      cell: (info) => {
        const { type, amount } = info.row.original;
        return type === "deposit" ? amount?.toFixed(2) : "";
      },
      footer: (info) => {
        const total = info.table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => {
            const { type, amount } = row.original;
            return type === "deposit" ? sum + Number(amount || 0) : sum;
          }, 0);
        return `${total.toFixed(2)}`;
      },
    },
    {
      header: lang.Withdrawal || "Withdraw",
      accessorKey: "withdraw",
      cell: (info) => {
        const { type, amount } = info.row.original;
        return type === "withdraw" ? amount?.toFixed(2) : "";
      },
      footer: (info) => {
        const total = info.table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => {
            const { type, amount } = row.original;
            return type === "withdraw" ? sum + Number(amount || 0) : sum;
          }, 0);
        return `${total.toFixed(2)}`;
      },
    },
    {
      header: lang["Balance"] || "Balance",
      footer: (info) => {
        if (!investor)
          return (
            lang["Select an investor to display"] ||
            "Select an investor to display"
          );

        const totalWithdraw = info.table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => {
            const { type, amount } = row.original;
            return type === "withdraw" ? sum + Number(amount || 0) : sum;
          }, 0);

        const totalDeposit = info.table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => {
            const { type, amount } = row.original;
            return type === "deposit" ? sum + Number(amount || 0) : sum;
          }, 0);

        return `${
          totalDeposit.toFixed(2) - totalWithdraw.toFixed(2)
        }`;
      },
    },
    {
      header: lang.Note || "Notes",
      accessorKey: "statement",
      cell: (row) => <TextComponent text={row.getValue() || ""} />,
    },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <Receipt
          lang={lang}
          receiptData={row.row.original}
          branchData={branch}
          idx={row.row.index}
        />
      ),
    },
  ];

  useEffect(() => {
    if (filter !== "from_to") {
      setFrom();
      setTo();
    }
    if (branchId) {
      axios
        .get(apiKey + "/transaction-reports", {
          params: {
            branch_id: branchId,
            filter,
            investor_id: investor,
            from,
            to,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setData(res.data.result);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [branchId, filter, investor, from, to, token]);

  useEffect(() => {
    axios
      .get(apiKey + "/investor", {
        params: {
          branch_id: branchId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setInvestorList(res.data.result);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [branchId, token]);

  useEffect(() => {
    if (branchId) {
      axios
        .get(`${apiKey}/get-dealer/${branchId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setBranch(res.data.result[0]);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [branchId, token]);

  return (
    <main className="main" id="main">
      <div className="pagetitle">
        <h1>
          {lang.Investment_Loan_Management || "Investment/Loan Management"}
        </h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
              >
                <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
              </svg>
            </li>
            <li className="breadcrumb-item">
              {lang.Investment_Loan_Management || "Investment/Loan Management"}
            </li>
            <li className="breadcrumb-item active">
              {lang["Investor Statement"] || "Investor Statement"}
            </li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="mt-3 mb-3">
                  <div className="rr">
                    {lang["Investor Statement"] || "Investor Statement"}
                  </div>
                  <div className="row justify-content-end gap-2">
                    {filter === "from_to" && (
                      <>
                        <div className="custom-datepicker">
                          <DatePicker
                            placeholder={lang["from_text"] || "From"}
                            style={{
                              left: "35%",
                              top: "5px",
                              height: "auto",
                            }}
                            containerStyle={{
                              height: "auto",
                            }}
                            onChange={(e) => {
                              const dateObject = new Date(e);
                              setFrom(dateObject);
                            }}
                          />
                        </div>
                        <div className="custom-datepicker">
                          <DatePicker
                            className=" btn-exportform-control w-100"
                            placeholder={lang["to_text"] || "To"}
                            style={{
                              left: "45%",
                              top: "5px",
                              height: "auto",
                            }}
                            containerStyle={{
                              height: "auto",
                            }}
                            onChange={(e) => {
                              const dateObject = new Date(e);
                              setTo(dateObject);
                            }}
                          />
                        </div>
                      </>
                    )}
                    <select
                      onChange={(e) => setFilter(e.target.value)}
                      className="btn-export me-0 mb-4 mb-md-0 col-3"
                      name="time"
                      id="time"
                    >
                      <option value="">{lang.All_Time || "All Time"}</option>
                      <option value="today">{lang.Today || "Today"}</option>
                      <option value="this_week">
                        {lang.This_Week || "This Week"}
                      </option>
                      <option value="this_month">
                        {lang.This_Month || "This Month"}
                      </option>
                      <option value="this_year">
                        {lang.This_Year || "This Year"}
                      </option>
                      <option value="from_to">
                        {lang["From To"] || "From To"}
                      </option>
                    </select>
                    <select
                      onChange={(e) => setInvestor(e.target.value)}
                      className="btn-export col-3"
                      name="inv"
                      id="inv"
                    >
                      <option value="">
                        {lang.all_investors || "All Investors"}
                      </option>
                      {investorList.map((investor, index) => (
                        <option key={index} value={investor.id}>
                          {investor.FullName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div classNames="d-flex mt-3 mb-3">
                  <Table
                    lang={lang}
                    data={data}
                    columns={columns}
                    footer={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default InvestorStatment;
